export default __webpack_public_path__ + "static/media/close-icon.28dbe22c.svg";